import axios from "@/axios.js"
import CampaignService from "./campaign_service";
export default {
  searchCampaign({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("api/campaigns/search_campaign", {
          item: item
        })
        .then((response) => {
          commit('SET_CAMPAIGN', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  searchCampaignReviewCampaignResults({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("api/campaigns/search_campaign_review_campaign_results", {
          item: item
        })
        .then((response) => {
          commit('SET_CAMPAIGN', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  searchSubmittedHours({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("api/campaigns/search_submitted_hours", {
          item: item
        })
        .then((response) => {
          commit('SET_SUBMITTED_HOURS', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  filterStartEndDate({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("api/campaigns/filter_start_end_date", {
          item: item
        })
        .then((response) => {
          commit('SET_SUBMITTED_HOURS', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getSubmitHoursSalesDevelopers({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("api/campaigns/get_submit_hours_sales_developers", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getAllSubmitHoursSalesDevelopers({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("api/campaigns/get_all_submit_hours_sales_developers", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getAllSalesDevelopers({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("api/campaigns/get_all_sales_developers", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getAllSubmitHoursClients({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("api/campaigns/get_all_clients_submit_hours", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  filterManagerStartEndDate({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("api/campaigns/filter_manager_start_end_date", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchSelectedSubmitHours({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/campaigns/fetch_selected_submit_hours", {
          item: item
        })
        .then((response) => {
          commit('SET_SELECTED_SUBMIT_HOURS', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchManagerSelectedSubmitHours({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/campaigns/fetch_manager_selected_submit_hours", {
          item: item
        })
        .then((response) => {
          commit('SET_MANAGER_SELECTED_SUBMIT_HOURS', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  searchWithCampaignOnly({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("api/campaigns/search_with_campaign_only", {
          item: item
        })
        .then((response) => {
          commit('SET_CAMPAIGN', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchSubmitHourById({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/campaigns/submit_hour/" + item)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  checkUniqueCampaignCode({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/campaigns/check_campaign_code/" + item)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllCampaignsWithFilter({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/campaigns/campaigns_with_filter", {
          item: item
        })
        .then((response) => {
          commit('SET_CAMPAIGN', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
    updateCommentsToHistoricNotes({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/campaigns/update_comments_to_historic_notes", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
      importGrade3ContctsToGrade3RebuildTable({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/campaigns/import_grade3_contacts_to_grade3_rebuild_table", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  
  getParent({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/campaigns/${item}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  checkCompanyExists({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/campaigns/check_company_exists", {
          item: item
        })
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  searchAutocomplete({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/campaign/search/" + item)
        .then((response) => {
          // // console.log(response)
          commit('SET_AUTOCOMPLETE_DATA', response.data.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateCampaign({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/campaigns/update_campaign", {
          item: item
        })
        .then((response) => {
          // // console.log(response)
          commit('EDIT_ITEM', Object.assign(item, {
            id: response.data.id
          }))
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchStatus(context, statusId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/campaigns/status/${statusId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addCampaign({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/campaigns/add_campaign", {
          item: item
        })
        .then((response) => {
          // // console.log(response)
          commit('ADD_ITEM', Object.assign(item, {
            id: response.data.id
          }))
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllCampaigns({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("/api/campaigns/" + item.page_no + "/" + item.per_page)
        .then((response) => {
          commit('SET_CAMPAIGN', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllCampaignsWithSteps({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("/api/campaigns/campaign_with_steps/" + item.page_no + "/" + item.per_page)
        .then((response) => {
          commit('SET_CAMPAIGN', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchSingleCampaignsWithSteps({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("/api/campaigns/single_campaign_with_steps/" + item)
        .then((response) => {
          commit('SET_CAMPAIGN', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllCampaignsWithStepsWithFilter({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/campaigns/campaigns_with_steps_with_filter", {
          item: item
        })
        .then((response) => {
          commit('SET_CAMPAIGN', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchCampaignsWithStepsForClientUser({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/campaigns/campaigns_with_steps_for_client_user", {
          item: item
        })
        .then((response) => {
          commit('SET_CAMPAIGN', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchSalesDeveloperAssociatedCampaigns({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("/api/campaigns/sales_developer/" + item.sales_developer_id + "/" + item.page_no + "/" + item.per_page)
        .then((response) => {
          commit('SET_CAMPAIGN', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllCampaignsAsClient({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/campaigns/client", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchCampaign(context, campaignUserId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/campaigns/${campaignUserId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  checkCampaignPrimaryClient({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/campaigns/check_primary_client", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchCampaignWithClients(context, campaignUserId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/campaigns/get_a_campaign_with_clients/${campaignUserId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchCampaignList({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/campaigns/${item}`)
        .then((response) => {
          commit('SELECTED_CAMPAIGN', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getCampaignStatus({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/campaigns/get_campaign_status")
        .then((response) => {
          // // console.log(response)
          commit('SET_CAMPAIGN_STATUS', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getAllCoreFields({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/campaigns/get_all_core_fields")
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getAllMasterFields({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/campaigns/get_all_master_fields")
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchPrimaryClientFields({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/campaigns/get_primary_client_fields/${item}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchCampaignClients({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/campaigns/fetch_campaign_clients/${item}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchCampaignFields({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/campaigns/get_campaign_fields/${item}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchOpportunityFields({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/campaigns/get_opportunity_fields/${item}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchClientFieldsByClientId({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/campaigns/get_client_fields_by_client_id", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeCampaign({
    commit
  }, campaignUserId) {
    return new Promise((resolve, reject) => {
      // alert(campaignUserId)
      axios.delete(`/api/campaigns/campaign_delete/${campaignUserId}`)
        .then((response) => {
          commit('REMOVE_CLIENT', campaignUserId)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addWorkingHours({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/campaigns/add_working_hours", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateWorkingHours({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/campaigns/update_working_hours", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  Exceed15hoursUpdateWorkingHours({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/campaigns/exceed_15hours_update_working_hours", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  showPreviousWorkingHours({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/campaigns/show_previous_working_hours", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getWorkingHoursPerDay({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/campaigns/get_working_hours_per_day", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchApprovalSubmitHours({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/campaigns/get_approval_submit_hours", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
approveWorkingHours({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/approve_working_hours", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
approveExceed15WorkingHours({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/approve_exceed_15_working_hours", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
declineWorkingHours({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/decline_working_hours", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
declineExceed15WorkingHours({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/decline_exceed_15_working_hours", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
fetchSubmitHours({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/fetch_submit_hours", {
        item: item
      })
      .then((response) => {
        commit('SET_USER_SUBMITTED_HOURS', response.data)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
fetchManagerSubmitHours({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/fetch_manager_submit_hours", {
        item: item
      })
      .then((response) => {
        commit('SET_MANAGER_SUBMITTED_HOURS', response.data)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
addCampaignSteps({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/add_campaign_steps", {
        item: item
      })
      .then((response) => {
        // // console.log(response)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
editCampaignSteps({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/edit_campaign_steps", {
        item: item
      })
      .then((response) => {
        // // console.log(response)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
addCustomCampaignSteps({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/add_custom_campaign_steps", {
        item: item
      })
      .then((response) => {
        // // console.log(response)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
fetchCampaignCustomSteps(context, campaignUserId) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_custom_campaign_steps/${campaignUserId}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
fetchCampaignStepByStepId(context, stepId) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_campaign_step_by_step_id/${stepId}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
saveArrangedCampaignSteps({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/save_arranged_campaign_steps", {
        item: item
      })
      .then((response) => {
        // // console.log(response)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
fetchCampaignSteps(context, camapignId) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/campaign_steps/${camapignId}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
fetchArrangedCampaignSteps(context, camapignId) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/arranged_campaign_steps/${camapignId}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getAllCampaignsForGrid({ commit }, item) {
  return new Promise((resolve, reject) => {
    CampaignService.getAllCampaignsForGrid(item, (rows, lastRow) => {
      // // console.log(lastRow);
      resolve({ rows: rows, lastRow: lastRow });
    });
  });
},
getAllCampaignsCascadingFieldsForGrid({ commit }, item) {
  return new Promise((resolve, reject) => {
    CampaignService.getAllCampaignsCascadingFieldsForGrid(item, (rows, lastRow) => {
      // console.log(lastRow);
      resolve({ rows: rows, lastRow: lastRow });
    });
  });
},
getAllCampaignsForGrid({ commit }, item) {
  return new Promise((resolve, reject) => {
    CampaignService.getAllCampaignsForGrid(item, (rows, lastRow) => {
      // console.log(lastRow);
      resolve({ rows: rows, lastRow: lastRow });
    });
  });
},
getAllCampaignsForGridForPopulateData({ commit }, item) {
  return new Promise((resolve, reject) => {
    CampaignService.getAllCampaignsForGridForPopulateData(item, (rows, lastRow) => {
      // console.log(lastRow);
      resolve({ rows: rows, lastRow: lastRow });
    });
  });
},
getAllCampaignsForAccountContactRequestPopulateData({ commit }, item) {
  return new Promise((resolve, reject) => {
      CampaignService.getAllCampaignsForAccountContactRequestPopulateData(item, (rows, lastRow) => {
      // console.log(lastRow);
      resolve({ rows: rows, lastRow: lastRow });
    });
  });
},
getAllCampaignsForGridForSelectedFields({ commit }, item) {
  return new Promise((resolve, reject) => {
    CampaignService.getAllCampaignsForGridForSelectedFields(item, (rows, lastRow) => {
      // console.log(lastRow);
      resolve({ rows: rows, lastRow: lastRow });
    });
  });
},
getAllCampaignsForReviewCampaignResultsGrid({ commit }, item) {
  return new Promise((resolve, reject) => {
    CampaignService.getAllCampaignsForReviewCampaignResultsGrid(item, (rows, lastRow) => {
      // console.log(lastRow);
      resolve({ rows: rows, lastRow: lastRow });
    });
  });
},
getAllCampaignsForReviewCampaignResultsGridClientSide({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/campaigns/get_all_campaigns_for_reviw_campaign_results_grid_client_side", {
        item: item
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
getAllCampaignsForAccountContactRequests({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/campaigns/get_all_campaigns_for_account_contact_requests", {
        item: item
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
addAccountCoreFieldsToCampaign({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/campaigns/add_account_core_fields_to_campaign", {
        item: item
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
addContactCoreFieldsToCampaign({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/campaigns/add_contact_core_fields_to_campaign", {
        item: item
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
addCoreFieldsToCampaign({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/campaigns/add_core_fields_to_campaign", {
        item: item
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
addMasterFieldsToCampaign({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/campaigns/add_master_fields_to_campaign", {
        item: item
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
addClientFieldsToCampaign({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/campaigns/add_client_fields_to_campaign", {
        item: item
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
addCampaignFieldsToCampaign({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/campaigns/add_campaign_fields_to_campaign", {
        item: item
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
addOpportunityFieldsToCampaign({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/campaigns/add_opportunity_fields_to_campaign", {
        item: item
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
addMandatoryFieldsToCampaign({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/campaigns/add_mandatory_fields_to_campaign", {
        item: item
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
updateAccountCoreFieldsToCampaign({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/campaigns/update_account_core_fields_to_campaign", {
        item: item
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
updateContactCoreFieldsToCampaign({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/campaigns/update_contact_core_fields_to_campaign", {
        item: item
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
updatMandatoryFieldsToCampaign({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/campaigns/update_mandatory_fields_to_campaign", {
        item: item
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
updateMasterFieldsToCampaign({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/campaigns/update_master_fields_to_campaign", {
        item: item
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
updateClientFieldsToCampaign({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/campaigns/update_client_fields_to_campaign", {
        item: item
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
updateCampaignFieldsToCampaign({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/campaigns/update_campaign_fields_to_campaign", {
        item: item
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
updateOpportunityFieldsToCampaign({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/campaigns/update_opportunity_fields_to_campaign", {
        item: item
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
updateOverallCampaignFieldsWithCampaignId({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/campaigns/update_overall_campaign_fields_with_campaign_id", {
        item: item
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
submitOverallCampaignFieldsWithCampaignId({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/campaigns/submit_overall_campaign_fields_with_campaign_id", {
        item: item
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
getSelectedMandatoryFields({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_selected_mandatory_fields/${item}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getSelectedMasterFields({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_selected_master_fields/${item}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getSelectedAccountCoreFields({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_selected_account_core_fields/${item}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getSelectedContactCoreFields({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_selected_contact_core_fields/${item}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getSelectedClientFields({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_selected_client_fields/${item}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getSelectedCampaignFields({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_selected_campaign_fields/${item}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getSelectedOpportunityFields({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_selected_opportunity_fields/${item}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
addCascadeFields({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/campaigns/add_cascade_fields", {
        item: item
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
addFieldValues({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/campaigns/add_field_values", {
        item: item
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
updateCascadeFields({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/campaigns/update_cascade_fields", {
        item: item
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
deleteCascadeFields({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/campaigns/delete_cascade_fields", {
        item: item
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
getCascadedField({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_cascaded_field/${item}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
populateSDData({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/populate_sd_data/${item}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
refreshDataSDData({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/refresh_sd_data/${item}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
refreshRebuildDataSDData({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/refresh_rebuild_sd_data/${item}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
populateAdditionalSDData({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/populate_additional_sd_data/${item}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
populateAccountContactRequestData({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/populate_account_contact_request_data/${item}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
getSDAccountColumns(context, campaignId) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_sd_qc_account_columns/${campaignId}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getSDContactsColumns(context, campaignId) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_sd_qc_contact_columns/${campaignId}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getSDAccountSelectedFields(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_sd_account_selected_fields", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getSDContactSelectedFields(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_sd_contact_selected_fields", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getSalesDeveloperHistoricCampaignsForGrid({ commit }, item) {
  return new Promise((resolve, reject) => {
    CampaignService.getSalesDeveloperHistoricCampaignsForGrid(item, (rows, lastRow) => {
      // console.log(lastRow);
      resolve({ rows: rows, lastRow: lastRow });
    });
  });
},
getSalesDeveloperLiveCampaignsForGrid({ commit }, item) {
  return new Promise((resolve, reject) => {
    CampaignService.getSalesDeveloperLiveCampaignsForGrid(item, (rows, lastRow) => {
      // console.log(lastRow);
      resolve({ rows: rows, lastRow: lastRow });
    });
  });
},
getDataAdministrationCampaignsForGrid(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_data_administration_campaigns_for_grid", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getBuildAccountCampaignsForGrid(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_build_account_campaigns_for_grid", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getBuildContactCampaignsForGrid(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_build_contact_campaigns_for_grid", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getContactsDataAdministrationCampaignsForGrid(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_contacts_data_administration_campaigns_for_grid", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getCampaignsWithAccountsThatHaveNoContacts(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_campaigns_with_accounts_that_have_no_contacts", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getCampaignsOfAccountsRequiringRebuild(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_campaigns_of_accounts_requiring_rebuild", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getCampaignsOfAccountsRequiringRebuildForDataAdministration(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_campaigns_of_accounts_requiring_rebuild_for_data_administration", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getCampaignsOfContactsRequiringRebuildForDataAdministration(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_campaigns_of_contacts_requiring_rebuild_for_data_administration", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getCampaignsOfGrade3ContactsRequiringRebuildForDataAdministration(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_campaigns_of_grade_3_contacts_requiring_rebuild_for_data_administration", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getCampaignsOfContactsRequiringRebuild(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_campaigns_of_contacts_requiring_rebuild", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getCampaignsOfGrade3Rebuild(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_campaigns_of_grade_3_rebuild", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getCampaignsOfAccountRequest(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_campaigns_of_account_request", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getCampaignsOfContactRequest(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_campaigns_of_contact_request", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getDataAdministrationCampaignsOfAccountRequest(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_data_administration_campaigns_of_account_request", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getDataAdministrationCampaignsOfContactRequest(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_data_administration_campaigns_of_contact_request", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
buildCampaignsWithAccountsThatHaveNoContacts(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/build_campaigns_with_accounts_that_have_no_contacts", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
  updateSalesDeveloperIds(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/update_sales_developer_ids_on_campaign", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
updateDataAdministratorIds(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/update_data_administrator_ids_on_campaign", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
assignAccountForRebuild(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/assign_account_for_rebuild", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
assignAccountRequestToDataAdmin(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/assign_account_request_to_data_admin", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
assignContactRequestToDataAdmin(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/assign_contact_request_to_data_admin", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
assignGrade3ContactsForRebuild(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/assign_grade_3_contacts_for_rebuild", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
assignContactsForRebuild(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/assign_contacts_for_rebuild", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
updateHasContactsInCampaignDataAdministratorId(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/update_has_contacts_in_campaign_data_administrator_id_on_campaign", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
updateContactDataAdministratorIds(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/update_contact_data_administrator_ids_on_campaign", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
updateTagToSDAccount(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/update_tag_to_sd_account", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
updateTagToSDContact(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/update_tag_to_sd_contact", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getSelectedAccountFields(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_selected_account_fields", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
fetchAccountContactRequestRecords(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_account_contact_request_records", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
fetchContactRequestRecordsByTableId(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_contact_request_records_by_table_id", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getSelectedContactFields(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_selected_contact_fields", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getSelectedOpportunityFields(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_selected_opportunity_fields", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getSelectedContactFieldsWithDetails(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_selected_contact_fields_with_details", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getSelectedAccountFieldsWithDetails(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_selected_account_fields_with_details", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getAllAccountOtherFieldsWithDetails(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .get("/api/campaigns/get_all_account_other_fields_with_details", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getAllContactOtherFieldsWithDetails(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .get("/api/campaigns/get_all_contact_other_fields_with_details", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
// getAccountOtherFieldsValues(context, item) {
//   return new Promise((resolve, reject) => {
//     axios
//     .post("/api/campaigns/all_other_fields_values", {
//       item: item
//     }).then((response) => {
//         resolve(response)
//       })
//       .catch((error) => {
//         reject(error)
//       })
//   })
// },
getAlreadySelectedFields(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_already_selected_fields", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getAllGradeSteps(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_all_grade_steps", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getAllGradeStepsByGradeId(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_all_grade_steps_by_grade_id", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
updateSDOpportunity(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/update_sd_opportunity", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getAllOpportunityFields(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_all_opportunity_fields", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getSDAccountData(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_sd_account_data", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
updateSelectedGradeOnSDContact(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/update_selected_grade_on_sd_contact", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getContactNotes({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/campaigns/get_contact_notes", {
        item: item
      })
      .then(response => {
        
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
getDialCounts({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/campaigns/get_dial_counts", {
        item: item
      })
      .then(response => {
        
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
getAccountNotes({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/campaigns/get_account_notes", {
        item: item
      })
      .then(response => {
        
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
fetchAllSDStatus({
  commit
}) {
  return new Promise((resolve, reject) => {
    axios.get("/api/campaigns/get_all_sd_status")
      .then((response) => {
        // console.log("sdtfsdtftsdtfsdfsdf")
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
updateStatusToSDAccount(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/update_status_to_sd_account", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
submitSaveViewAction(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/save_sd_view", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
saveOpportunitiesSavedView(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/save_opportunities_saved_view", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
saveSDOpportunitiesSavedView(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/sd_save_opportunities_saved_view", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getOpportunitiesSavedViewLists(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_opportunities_view_lists", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getClientOpportunitiesSavedViewLists(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_client_opportunities_view_lists", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getSDOpportunitiesSavedViewLists(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_sd_opportunities_default_views", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getSDViewLists(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_sd_view_lists", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getCampaignReviewChanges({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/get_campaign_review_changes", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getCampaignAccountContactRequestReviewChanges({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/get_campaign_account_contact_request_review_changes", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getCampaignOpportunityReviewChanges({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/get_campaign_opportunity_review_changes", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
reviewerAccepted({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/reviewer_accepted", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
reviewerAccountRequestAccepted({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/reviewer_account_request_accepted", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
reviewerRejected({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/reviewer_rejected", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
reviewerAccountRequestRejected({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/reviewer_account_request_rejected", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
reviewerContactRequestRejected({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/reviewer_contact_request_rejected", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
reviewerContactRequestAccepted({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/reviewer_contact_request_accepted", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
reviewerOpportunityAccepted({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/reviewer_opportunity_accepted", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
reviewerOpportunityRejected({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/reviewer_opportunity_rejected", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getCampaignOtherFieldData({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/get_campaign_other_field_data", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getCampaignContactOtherFieldData({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/get_campaign_contact_other_field_data", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
campaignFieldDataAction({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/campaign_field_data_action", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
campaignContactFieldDataAction({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/campaign_contact_field_data_action", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getCampaignReviewChangesAccountDetail({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/get_campaign_review_changes_account_detail", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getCampaignReviewChangesContactDetail({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/get_campaign_review_changes_contact_detail", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getUnReviewedCampaigns({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_unreviewed_campaigns`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
getAccountContactRequestUnReviewedCampaigns({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_account_contact_request_unreviewed_campaigns`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
validateSDAccountDataWithMasterDB({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/validate_sd_account_data_with_master_db/${item}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
validateAccountClientViewDataWithMasterDB({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/validate_client_view_account_data_with_master_db/${item}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
validateSDContactDataWithMasterDB({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/validate_sd_contact_data_with_master_db/${item}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
validateContactClientViewDataWithMasterDB({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/validate_client_view_contact_data_with_master_db/${item}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
refreshValidateSDAccountDataWithMasterDB({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/refresh_validate_sd_account_data_with_master_db/${item}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
refreshValidateAccountClientViewDataWithMasterDB({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/refresh_validate_client_view_account_data_with_master_db/${item}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
refreshValidateSDContactDataWithMasterDB({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/refresh_validate_sd_contact_data_with_master_db/${item}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
refreshValidateContactClientViewDataWithMasterDB({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/refresh_validate_client_view_contact_data_with_master_db/${item}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},

getCampaignsForClient({ commit }, item) {
  return new Promise((resolve, reject) => {
    CampaignService.getCampaignsForClient(item, (rows, lastRow) => {
      // console.log(lastRow);
      resolve({ rows: rows, lastRow: lastRow });
    });
  });
},
fetchClientViewAccountFields({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_client_view_account_fields/${item}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
fetchClientViewOpportunityFields({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_client_view_opportunity_fields/${item}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
fetchClientViewContactFields({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_client_view_contact_fields/${item}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
fetchAlreadySelectedDefaultFields({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_already_selected_default_fields/${item}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
addDefaultFields({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/campaigns/add_default_fields_for_client_view", {
        item: item
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
addselectedFilterFields({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/campaigns/add_selected_filter_fields", {
        item: item
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
getColumnsForDefaultClientView(context, campaignId) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_columns_for_default_client_view/${campaignId}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
submitClientUserDefaultViewAction(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/save_client_user_default_view", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getClientUserDefaultViews(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_client_user_default_views", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getClientUserViews(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_client_user_views", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
searchCommentField({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("api/campaigns/search_comment_field", {
        item: item
      })
      .then((response) => {
        commit('SET_COMMENT_FIELD', response.data)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getCampaignGrades(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_all_campaign_grades", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
addGradeCategory({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/add_campaign_grade_category", {
        item: item
      })
      .then((response) => {
        // // console.log(response)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
updateGradeCategory({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/update_campaign_grade_category", {
        item: item
      })
      .then((response) => {
        // // console.log(response)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
deleteGradeCategory({
  commit
}, gradeCategoryId) {
  return new Promise((resolve, reject) => {
    axios.delete(`/api/campaigns/grade_category_delete/${gradeCategoryId}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getAllCampaignGradeCategories({ commit }, item) {
  return new Promise((resolve, reject) => {
    CampaignService.getAllCampaignGradeCategories(item, (rows, lastRow) => {
      // console.log(lastRow);
      resolve({ rows: rows, lastRow: lastRow });
    });
  });
},
fetchGradeCategory({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/fetch_grade_category/${item}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
fetchAllGradeByCampaignId({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/fetch_all_grade_by_campaign_id/${item}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
listClientDashboardDataSets({
  commit
}, item) {
  return new Promise((resolve, reject) => {
   axios.get("/api/campaigns/list-client-dashboard-data-sets")
       .then((response) => {
         resolve(response)
       })
      .catch((error) => {
        reject(error)
      })
  })
},
updateCampaignDashboard({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("api/campaigns/update_campaign_dashboard", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
addCampaignDashboardWithPermission({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/add_campaign_dashboard_with_permission", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
updateCampaignDashboardPermission({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/update_campaign_dashboard_permission", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
updateCampaignAlertRecipients({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/update_campaign_alert_recipients", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
removeCampaignDashboardWithPermission({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/remove_campaign_dashboard_with_permission", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getAllDashboardUserPermission({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/get_all_dashboard_user_permission", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
removeNotPermissionUserForDashboard({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/remove_not_permission_user_for_dashboard", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
removeNotPermissionUserForAlertRecipients({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/remove_not_permission_user_for_alert_recipients", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
updateClientBillableHour({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/update_client_billable_hour", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
updateHour({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/update_hour", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
fetchCampaignStatistics({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/get_campaign_statistics", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
addDocsTemplate({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/add_docs_template", {
        item: item
      })
      .then((response) => {
        // console.log(response)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
addDocsTemplateVariable({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/add_docs_template_variable", {
        item: item
      })
      .then((response) => {
        // console.log(response)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
updateDocsTemplateVariable({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/update_docs_template_variable", {
        item: item
      })
      .then((response) => {
        // console.log(response)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getAllDocsTemplate({ commit }, item) {
  return new Promise((resolve, reject) => {
    CampaignService.getAllDocsTemplate(item, (rows, lastRow) => {
      // console.log(lastRow);
      resolve({ rows: rows, lastRow: lastRow });
    });
  });
},
getAllImageUpload({ commit }, item) {
  return new Promise((resolve, reject) => {
    CampaignService.getAllImageUpload(item, (rows, lastRow) => {
      // console.log(lastRow);
      resolve({ rows: rows, lastRow: lastRow });
    });
  });
},
fetchDocsTemplate({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/fetch_docs_template/${item}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
updateDocsTemplate({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/update_docs_template", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
deleteDocsTemplate({
  commit
}, docsId) {
  return new Promise((resolve, reject) => {
    axios.delete(`/api/campaigns/docs_delete/${docsId}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
deleteImage({
  commit
}, imageId) {
  return new Promise((resolve, reject) => {
    axios.delete(`/api/campaigns/image_delete/${imageId}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getDocsTemplateLists({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_docs_template_list`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getEmailTemplateLists({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_email_template_list`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
addEmailTemplate({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/add_email_template", {
        item: item
      })
      .then((response) => {
        // console.log(response)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
addEmailTemplateVariable({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/add_email_template_variable", {
        item: item
      })
      .then((response) => {
        // console.log(response)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getAllEmailTemplate({ commit }, item) {
  return new Promise((resolve, reject) => {
    CampaignService.getAllEmailTemplate(item, (rows, lastRow) => {
      // console.log(lastRow);
      resolve({ rows: rows, lastRow: lastRow });
    });
  });
},
fetchEmailTemplate({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/fetch_email_template/${item}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
updateEmailTemplate({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/update_email_template", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
deleteEmailTemplate({
  commit
}, emailId) {
  return new Promise((resolve, reject) => {
    axios.delete(`/api/campaigns/email_delete/${emailId}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getAllOpportunityAlerts({ commit }, item) {
  return new Promise((resolve, reject) => {
    CampaignService.getAllOpportunityAlerts(item, (rows, lastRow) => {
      // console.log(lastRow);
      resolve({ rows: rows, lastRow: lastRow });
    });
  });
},
addOpportunityDocument({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/add_opportunity_document", {
        item: item
      })
      .then((response) => {
        // console.log(response)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
emailOpportunityAlert({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/email_opportunity_alert", {
        item: item
      })
      .then((response) => {
        // console.log(response)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getCampaignOpportunityDocsLists({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_campaign_opportunity_docs_list/`+ item)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
downloadOpportunityDocs({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/download_opportunities_docs", {
        item: item,
      },{
        responseType: 'blob',
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
checkClientUserCampaignPermission(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/check_client_user_campaign_permission", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
checkSalesDeveloperCampaignPermission(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/check_sales_developer_campaign_permission", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getSelectedOpportunityFieldsWithDetails(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_selected_opportunity_fields_with_details", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getSDOpportunitiesColumns(context, campaignId) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_sd_opportunity_columns/${campaignId}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getClientOpportunities({ commit }, item) {
  return new Promise((resolve, reject) => {
    CampaignService.getClientOpportunities(item, (rows, lastRow) => {
      resolve({ rows: rows, lastRow: lastRow });
    });
  });
},
getSDOpportunities({ commit }, item) {
  return new Promise((resolve, reject) => {
    CampaignService.getSDOpportunities(item, (rows, lastRow) => {
      resolve({ rows: rows, lastRow: lastRow });
    });
  });
},
updateSDCreatedOpportunity({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/update_sd_created_opportunity", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
addUploadedImage({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/add_uploaded_image", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getAdminClientViewCampaignDataSource({ commit }, item) {
  return new Promise((resolve, reject) => {
    CampaignService.getAdminClientViewCampaignDataSource(item, (rows, lastRow) => {
      // console.log(lastRow);
      resolve({ rows: rows, lastRow: lastRow });
    });
  });
},
getAdminClientAndUserViewCampaignDataSource({ commit }, item) {
  return new Promise((resolve, reject) => {
    CampaignService.getAdminClientAndUserViewCampaignDataSource(item, (rows, lastRow) => {
      // console.log(lastRow);
      resolve({ rows: rows, lastRow: lastRow });
    });
  });
},
fetchCampaignUsers({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/fetch_campaign_user", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getDefaultViewDataSource({ commit }, item) {
  return new Promise((resolve, reject) => {
    CampaignService.getDefaultViewDataSource(item, (rows, lastRow) => {
      // console.log(lastRow);
      resolve({ rows: rows, lastRow: lastRow });
    });
  });
},

getdefaultOpportunitiesViewDataSource({ commit }, item) {
  return new Promise((resolve, reject) => {
    CampaignService.getdefaultOpportunitiesViewDataSource(item, (rows, lastRow) => {
      // console.log(lastRow);
      resolve({ rows: rows, lastRow: lastRow });
    });
  });
},


deleteDefaultView({
  commit
}, imageId) {
  return new Promise((resolve, reject) => {
    axios.delete(`/api/campaigns/default_view_delete/${imageId}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
deleteDefaultOpportunitiesView({
  commit
}, imageId) {
  return new Promise((resolve, reject) => {
    axios.delete(`/api/campaigns/default_opportunities_view_delete/${imageId}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getDefaultViewSelectedUsers(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_default_views_selected_users", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getDefaultOpportunitiesViewSelectedUsers(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_default_opportunities_views_selected_users", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
updateDefaultViewAction(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/update_default_view_action", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
updateDefaultOpportuntiesViewAction(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/update_default_opportunities_view_action", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
updateSalesDeveloperDefaultViewAction(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/update_sales_developer_default_view_action", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
submitSDCampaignViewSettings(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/save_sd_campaign_view_settings", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
fetchAllSDCampaignViewSettings(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/fetch_all_sd_campaign_view_settings", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getContactOpportunities(context, item) {
  return new Promise((resolve, reject) => {
    axios
    .post("/api/campaigns/get_contact_opportuntiies", {
      item: item
    }).then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
deleteDocsOpportunity({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/campaigns/delete_opportunities_docs", {
        item: item,
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
checkAlreadySelectedFields({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/check_already_campaign_fields/${item}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getAllAccountSelectedCampaignColumns({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_all_account_selected_campaign_columns/${item}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getAllAccountSelectedCampaignColumnsForDataBuild({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_all_account_selected_campaign_columns_for_data_build/${item}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getAllAccountSelectedCampaignColumnsForRebuild({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_all_account_selected_campaign_columns_for_rebuild/${item}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getAllContactSelectedCampaignColumnsForRebuild({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_all_contact_selected_campaign_columns_for_rebuild/${item}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getAllContactSelectedCampaignColumns({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_all_contact_selected_campaign_columns/${item}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getAllContactSelectedCampaignColumnsForDataBuild({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_all_contact_selected_campaign_columns_for_data_build/${item}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getAlreadySelectedCampaignField({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_already_selected_campaign_fields/${item}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
getAlreadySelectedAccountCampaignField({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/get_already_selected_account_campaign_fields/${item}`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
validateSDAndMasterDbData({ commit }, item) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/campaigns/validate_sd_and_master_db_data/${item}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
},
  getImportedExcelDataToMasterDBRecords({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/campaigns/get_imported_excel_data_to_master_db_records", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllClients({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/campaigns/fetch_all_clients`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllClientsForEdit({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/campaigns/fetch_all_clients_for_edit/${item}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
    getClientDashboardData(context, dashboardId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/campaigns/client-dashboard-data/${dashboardId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getSdAvailability({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/campaigns/sd_availability", { item: item })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getSdAllocationSummary(context, campaignId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/campaigns/sd_allocation_summary/${campaignId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getSdAllocationHistory(context, campaignId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/campaigns/sd_allocation_history/${campaignId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getMySdAllocation(context, campaignId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/campaigns/my_sd_allocation/${campaignId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getSdAllocationCompliance(context) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/campaigns/sd_allocation_compliance`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}
